import React, { useEffect, useState } from "react";
import TextField from "./TextField";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import ShortResponseForm from "./ShortResponseForm";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";
import QuestionResponseContainer from "./QuestionResponseContainer";

interface MultipleSelectionOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: MultipleSelectionOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const [ currentInputValue, setCurrentInputValue ] = useState<string>('');
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);

    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:currentInputValue}))
    }, [currentInputValue]);

    return (
        <QuestionResponseContainer question={question}>
            <div className="flex flex-col gap-4">
                <TextField placeholder="Enter your Response" inputValue={currentInputValue} setInputValue={setCurrentInputValue} styles='w-full md:w-11/12'/>
                {options.map((option: string) => {
                    return (
                        <div className="flex gap-5" key={option}>
                            <p>{option}</p>
                        </div>
                    );
                })}
            </div>
        </QuestionResponseContainer>
    )
}